import { FiltersButton, FromDateFilterBtn, ToDateFilterBtn } from "..";
import { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setFilters } from "store/filters/filtersSlice";
import { selectFilters } from "store/filters/selectors";
import { format } from "date-fns";
import { SearchPeopleIcon } from "assets/icons";
import styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";
import { enUS, es, fr, it, nl, de } from "date-fns/locale";

import i18next from "i18next";

const DatesFilterButton = () => {
  const localeMap = {
    en: enUS,
    es: es,
    fr: fr,
    it: it,
    nl: nl,
    de: de,
  };
  const [t, i18n] = useTranslation("global");
  const dispatch = useDispatch();
  const filters = useSelector(selectFilters);
  const [showDatesDropdown, setShowDatesDropdown] = useState(false);
  const dropdownRef = useRef(null); // Reference for the dropdown

  const toggleShowDatesDropdown = () => {
    setShowDatesDropdown(!showDatesDropdown);
  };

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDatesDropdown(false); // Close dropdown if clicked outside
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <div className={styles.datesWrapper} ref={dropdownRef}>
      <FiltersButton
        label={
          filters.from && filters.to
            ? `${format(filters.from, "d MMMM", {
                locale: localeMap[i18n.language],
              })} - ${format(filters.to, "d MMMM", {
                locale: localeMap[i18n.language],
              })}` // Both from and to selected
            : filters.from
            ? format(filters.from, "d MMMM", {
                locale: localeMap[i18n.language],
              }) // Only from selected
            : format(new Date(), "d MMMM", {
                locale: localeMap[i18n.language],
              }) // No date selected, show today's date
        }
        isActive={!!filters.from}
        onClick={toggleShowDatesDropdown}
      />
      {showDatesDropdown && (
        <div className={styles.datesDropdownWrapper}>
          <div className={styles.datePickerWrapper}>
            <p>{t("modal.newbooking.fromLabel")}</p>
            <FromDateFilterBtn />
          </div>
          <div className={styles.datePickerWrapper}>
            <p>{t("modal.newbooking.toLabel")}</p>
            <ToDateFilterBtn />
          </div>
        </div>
      )}
    </div>
  );
};

export default DatesFilterButton;
